// extracted by mini-css-extract-plugin
export var alpha = "_8w-4";
export var alphaInputContainer = "_8w-f";
export var badge = "_8w-b";
export var brandKitGrid = "_8w-h";
export var brandKitItem = "_8w-i";
export var brandKitSwatch = "_8w-j";
export var controls = "_8w-5";
export var formatDropdown = "_8w-d";
export var formatSelector = "_8w-c";
export var hex = "_8w-6";
export var hexInput = "_8w-e";
export var hue = "_8w-3";
export var hueAndAlphaPointer = "_8w-a";
export var percentageLabel = "_8w-g";
export var picker = "_8w-0";
export var rgba = "_8w-8";
export var rgbaSection = "_8w-7";
export var saturation = "_8w-1";
export var saturationPointer = "_8w-9";
export var sliders = "_8w-2";